/* Structural layout only — colors come from Astryx design tokens (resolved
   inside a <Theme> scope). */

.value {
  font-size: var(--font-size-4xl);
  font-weight: var(--font-weight-bold);
  line-height: 1.2;
}

.valueNeutral,
.valueAccent {
  color: var(--color-text-primary);
}

.valuePositive {
  color: var(--color-text-green);
}

.valueWarning {
  color: var(--color-text-orange);
}

.valueCritical {
  color: var(--color-error);
}
